let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6eDig")).then(() => parcelRequire('6cKKb'));